import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'placeholder-auction-card',
  templateUrl: './placeholder-auction-card.component.html',
  styleUrls: ['./placeholder-auction-card.component.scss'],
  imports: [CommonModule]
})
export class PlaceholderAuctionCardComponent implements OnInit {

  @Input()
  odd: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
